module.exports = "/_next/static/images/SANTAI_MTWI-42cbfdab4365aa046e257e48cdcc22a8.svg";